import React from "react";
import OrderDTO from "@/dto/order/OrderDTO";
import GlobalStore from "@/store";
import { buildPrintRules } from "./constants/printRules";
import { evaluatePrintRules } from "./utils/evaluatePrintRules";
import PrintRuleModal from "./components/PrintRuleModal";
import ForbiddenPrintRuleModal from "./components/ForbiddenPrintRuleModal";
import { ModalStore } from "@/hooks/Modal/ModalStore";
import { PrintCheckResult } from "./types";
import "./index.less";

function confirmForbiddenOrders(modalStore: ModalStore, result: PrintCheckResult): Promise<boolean> {
    return new Promise<boolean>((resolve) => {
        modalStore.openModal(ForbiddenPrintRuleModal, {
            result,
            onCancel: () => resolve(false),
            onContinue: () => resolve(true),
        });
    });
}

function selectPrintOrders(modalStore: ModalStore, result: PrintCheckResult): Promise<OrderDTO[]> {
    return new Promise<OrderDTO[]>((resolve) => {
        modalStore.openModal(PrintRuleModal, {
            result,
            onCancel: () => resolve([]),
            onSelectPrintOrders: (orders) => resolve(orders),
        });
    });
}

export async function checkBeforePrint(
    orders: OrderDTO[],
    addressFilterKeywords: string[],
    undeliverableAreaCodes: any[],
    globalStore: typeof GlobalStore,
    modalStore: ModalStore,
): Promise<OrderDTO[]> {
    await globalStore.warehouseWarningStore.ensure();

    const rules = buildPrintRules({
        addressFilterKeywords,
        undeliverableAreaCodes,
        globalStore,
    });

    const result = await evaluatePrintRules(orders, rules);
    const printableOrders = orders.filter((order) => !result.forbiddenOrderIds.has(order.id));

    if (result.forbidden.length) {
        const shouldContinue = await confirmForbiddenOrders(modalStore, result);

        if (!shouldContinue) {
            return [];
        }

        if (!printableOrders.length) {
            return [];
        }
    }

    if (result.optional.length) {
        return selectPrintOrders(modalStore, result);
    }

    return printableOrders;
}
